import { max, min, required } from '@features/userPanel/mobx/stores/validators';
import getPublicEnv from '@utils/getPublicEnv';
import { BASE_PATH } from '@config/index';

export const CUSTOMER_ADDRESS_TYPE = {
  basicAddress: 'BASIC',
  deliveryAddress: 'DELIVERY',
  invoiceAddress: 'INVOICE',
};

export const PAYMENT_ICON = {
  paypalWallet: {
    url: `${BASE_PATH}/img/paypal_transparent.svg`,
    height: 24,
  },
  visa: {
    url: `${BASE_PATH}/img/visa_transparent.svg`,
    height: 16,
  },
  mastercard: {
    url: `${BASE_PATH}/img/mastercard_transparent.svg`,
    height: 20,
  },
  amex: {
    url: `${BASE_PATH}/img/amex.svg`,
    height: 20,
  },
  openpay: {
    url: `${BASE_PATH}/img/openpay.svg`,
    height: 28,
  },
  bbva: {
    url: `${BASE_PATH}/img/bbva.svg`,
    height: 12,
  },
  banorte: {
    url: `${BASE_PATH}/img/banorte.svg`,
    height: 20,
  },
  citibanamex: {
    url: `${BASE_PATH}/img/citibanamex.svg`,
    height: 12,
  },
  spei: {
    url: `${BASE_PATH}/img/spei.jpg`,
    height: 28,
  },
  googlepay: {
    url: `${BASE_PATH}/img/checkout/googlepay.svg`,
    height: 16,
  },
  trustly: {
    url: `${BASE_PATH}/img/checkout/trustly.svg`,
    height: 16,
  },
};

export const PAYMENT_ICON_GRAY = {
  adyen: {
    urlGray: `${BASE_PATH}/img/checkout/adyen_gray.svg`,
    url: `${BASE_PATH}/img/checkout/adyen.svg`,
    height: 20,
    title: 'Adyen',
  },
  amex: {
    urlGray: `${BASE_PATH}/img/checkout/amex_gray.svg`,
    url: `${BASE_PATH}/img/checkout/amex.svg`,
    height: 16,
    title: 'American Express',
  },
  blik: {
    urlGray: `${BASE_PATH}/img/checkout/blik_gray.svg`,
    url: `${BASE_PATH}/img/checkout/blik.svg`,
    height: 16,
    title: 'BLIK',
  },
  mastercard: {
    urlGray: `${BASE_PATH}/img/checkout/mastercard_gray.svg`,
    url: `${BASE_PATH}/img/checkout/mastercard.svg`,
    height: 18,
    title: 'Mastercard',
  },
  paypal: {
    urlGray: `${BASE_PATH}/img/checkout/paypal_gray.svg`,
    url: `${BASE_PATH}/img/checkout/paypal.svg`,
    height: 18,
    title: 'PayPal',
  },
  przelewy: {
    urlGray: `${BASE_PATH}/img/checkout/przelewy_gray.svg`,
    url: `${BASE_PATH}/img/checkout/przelewy.svg`,
    height: 16,
    title: 'Przelewy24',
  },
  spei: {
    urlGray: `${BASE_PATH}/img/checkout/spei_gray.png`,
    url: `${BASE_PATH}/img/checkout/spei.jpg`,
    height: 20,
    title: 'SPEI',
  },
  visa: {
    urlGray: `${BASE_PATH}/img/checkout/visa_gray.svg`,
    url: `${BASE_PATH}/img/checkout/visa.svg`,
    height: 18,
    title: 'Visa',
  },
  googlepay: {
    urlGray: `${BASE_PATH}/img/checkout/googlepay_gray.svg`,
    url: `${BASE_PATH}/img/checkout/googlepay.svg`,
    height: 16,
    title: 'Google Pay',
  },
  bnpparibas: {
    urlGray: `${BASE_PATH}/img/checkout/bnpparibas_gray.svg`,
    url: `${BASE_PATH}/img/checkout/bnpparibas.svg`,
    height: 20,
    title: 'BNP Paribas',
  },
  applepay: {
    urlGray: `${BASE_PATH}/img/checkout/applepay_gray.svg`,
    url: `${BASE_PATH}/img/checkout/applepay.svg`,
    height: 16,
    title: 'Apple Pay',
  },
  trustly: {
    urlGray: `${BASE_PATH}/img/checkout/trustly_gray.svg`,
    url: `${BASE_PATH}/img/checkout/trustly.svg`,
    height: 16,
    title: 'Trustly',
  },
};

export const PAYMENT_PROVIDERS = {
  paypal: {
    id: 'PAYPAL',
    transactionMethods: {
      login: 'LOGIN',
      paypalplus: 'GUEST_CHECKOUT',
    },
  },
  openpay: {
    id: 'OPENPAY',
    transactionMethods: {
      card: 'CARD_CHARGES',
      transfer: 'BANK_TRANSFER',
    },
  },
  adyen: {
    id: 'ADYEN',
    transactionMethods: {
      onlinePayment: 'ONLINE_PAYMENT',
    },
  },
  BNP: {
    id: 'BNP',
    transactionMethods: {
      onlinePayment: 'ONLINE_INSTALLMENTS',
    },
  },
};

export const BNP_CONFIG = {
  AgreementNo: getPublicEnv('NEXT_PUBLIC_BNP_AGREEMENT_NUMBER'),
  CreditType: getPublicEnv('NEXT_PUBLIC_BNP_CREDIT_TYPE'),
  APP_OK: getPublicEnv('NEXT_PUBLIC_BNP_APP_OK'),
  APP_CANCEL: getPublicEnv('NEXT_PUBLIC_BNP_APP_CANCEL'),
  key: getPublicEnv('NEXT_PUBLIC_BNP_KEY'),
  materialCode: '335',
  materialName: 'Wyposażenie wnętrz',
  minTotals: 10000,
  maxTotals: 5000000,
};

export const PAYPAL_PLUS_CONFIG = {
  placeholder: 'paypalplus',
  language: 'es_MX',
  country: 'MX',
  mode: getPublicEnv('NEXT_PUBLIC_PAYPALPLUS_MODE'),
  scriptURL: 'https://www.paypalobjects.com/webstatic/ppplusdcc/ppplusdcc.min.js',
};

export const DIP_DELIVERY_ID = '2265dbe4-be05-4f79-8d0e-d8d3112f091b';
export const HOME_DELIVERY_ID = '8e412a07-aaae-452c-a858-7a01cfa851d0';
export const FAST_HOME_DELIVERY_ID = '4b665c0f-ae9a-4c29-b54c-4b557a71f5ad';
export const HOME_DELIVERY_WITH_BRING_SERVICE_PARTNER_ID = 'da52198f-7181-4eb0-87bf-c8be5ad58f8f';
export const HOME_DELIVERY_WITH_SERVICES_PARTNER_ID = '3c642d8c-05d3-49ce-8e7f-f0af7aa7cab1';
export const HOME_DELIVERY_WITH_SERVICES = '03e74309-49f9-4b18-9f6b-b08be260ef4a';
export const INPOST_DELIVERY_ID = 'ffa578fc-9a95-4ec2-9434-e9d57d6b8002';
export const POD_DELIVERY_ID = '39672a82-ca0c-4160-ad8a-fc4e56656f36';
export const COURIER_DELIVERY_ID = '04f39dc8-108a-4c04-b61e-b4616c49d98a';
export const DIP_DELIVERY_DAF_ID = '1c9a6c20-a43c-4325-ab2f-e177466953cd';

export const ADYEN_CONFIG = {
  environment: getPublicEnv('NEXT_PUBLIC_ADYEN_ENVIRONMENT'),
  clientKey: getPublicEnv('NEXT_PUBLIC_ADYEN_CLIENT_KEY'),
  analytics: {
    enabled: false,
  },
  paymentMethodsConfiguration: {
    card: {
      hasHolderName: true,
      holderNameRequired: true,
      billingAddressRequired: true,
    },
  },
};

export const DICTIONARY_TAX_REGIME_TYPE = 'TAX_REGIME';
export const DICTIONARY_COUNTRIES_TYPE = 'COUNTRIES';

const DefaultFieldMinLength = 2;
const DefaultFieldMaxLength = 256;
export const COMMON_VALIDATORS = [required(), min(DefaultFieldMinLength), max(DefaultFieldMaxLength)];

export const getDeliveryPackageLabel = (index: number) => `P${index + 1}`;
